export default __webpack_public_path__ + "ca95032b0a83f759b557be91edd075b2.webp";